import { render, staticRenderFns } from "./SidButtonsGroup.vue?vue&type=template&id=48247449"
import script from "./SidButtonsGroup.vue?vue&type=script&lang=js"
export * from "./SidButtonsGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports